/**
 * Camada Identidade visual — MIV Ecossis 2026 (skill ecossis-ui).
 * Mesmo formato de item do catálogo L1 (id, nome, paraQue, variantes).
 */

const MIV_CATALOG = [
  {
    grupo: 'Cores',
    items: [
      {
        id: 'miv-colors-primary',
        nome: 'Cores primárias',
        paraQue: 'Verde, azul institucional (#081E38) e branco (MIV pág. 21–22). Catálogo = HEX digital; impresso usa CMYK.',
        variantes: [
          { id: 'A', nome: 'Swatches + uso', mock: 'mivColorsPrimary' },
        ],
      },
      {
        id: 'miv-colors-secondary',
        nome: 'Cores secundárias',
        paraQue: 'Azul vibrante (#1C47A4), cinza e preto — diferenciação e neutros (MIV pág. 21). Usar depois das primárias.',
        variantes: [
          { id: 'A', nome: 'Swatches + uso', mock: 'mivColorsSecondary' },
        ],
      },
      {
        id: 'miv-colors-support',
        nome: 'Complementares (grafismos)',
        paraQue: 'Cores complementares do MIV para grafismos (págs. 34/38) — não são paleta institucional livre nem cores de setor.',
        variantes: [
          { id: 'A', nome: 'Swatches complementares', mock: 'mivColorsSupport' },
        ],
      },
      {
        id: 'miv-gradients',
        nome: 'Gradientes',
        paraQue: 'Duas combinações oficiais (MIV pág. 41). Máximo 3 cores; só sobre fundo chapado ou foto.',
        variantes: [
          { id: 'A', nome: 'Azul e azul–verde', mock: 'mivGradients' },
        ],
      },
      {
        id: 'miv-sectors',
        nome: 'Paleta por setor',
        paraQue: 'Identidade secundária por setor (MIV pág. 43) — nunca usar na marca institucional genérica; uma cor de setor por tela.',
        variantes: [
          { id: 'A', nome: 'Setores', mock: 'mivSectors' },
        ],
      },
    ],
  },
  {
    grupo: 'Tipografia',
    items: [
      {
        id: 'miv-type',
        nome: 'Exo',
        paraQue: 'Só Exo. Headings em bold. O resto em peso normal. Letter-spacing ≈ -25 (−0.02em).',
        variantes: [
          { id: 'A', nome: 'Escala tipográfica', mock: 'mivType' },
        ],
      },
    ],
  },
  {
    grupo: 'Logo',
    items: [
      {
        id: 'miv-logos',
        nome: 'Versões do logo',
        paraQue: 'Arquivos oficiais e quando usar cada um.',
        variantes: [
          { id: 'A', nome: 'Galeria de versões', mock: 'mivLogos' },
        ],
      },
      {
        id: 'miv-logo-combos',
        nome: 'Combinações de fundo',
        paraQue: 'Fundos permitidos do MIV (claro/escuro). Toggle é demo — não é página separada do PDF.',
        variantes: [
          { id: 'A', nome: 'Toggle claro / escuro', mock: 'mivLogoCombos' },
        ],
      },
      {
        id: 'miv-logo-safety',
        nome: 'Área de segurança e redução',
        paraQue: 'Margem mínima = altura tipográfica; redução mínima 40px na web.',
        variantes: [
          { id: 'A', nome: 'Demo 40px + margem', mock: 'mivLogoSafety' },
        ],
      },
    ],
  },
  {
    grupo: 'Grafismos e mídia',
    items: [
      {
        id: 'miv-grafismos',
        nome: 'Grafismos 1–3',
        paraQue: 'Oficiais MARCA: Graf 3 (entrelaçado), folha pulverizada e pattern (5–10% em chapado).',
        variantes: [
          { id: 'A', nome: 'Três grafismos + forma', mock: 'mivGrafismos' },
        ],
      },
      {
        id: 'miv-photo',
        nome: 'Fotografia + overlay',
        paraQue: 'Regra MIV (pág. 31): filtro azul #081E38 entre 5–15% sobre a foto. O slider é só demo pedagógica.',
        variantes: [
          { id: 'A', nome: 'Demo opacidade 5–15%', mock: 'mivPhoto' },
        ],
      },
    ],
  },
  {
    grupo: 'Aplicação em tela',
    items: [
      {
        id: 'miv-hierarchy',
        nome: 'Hierarquia de tela',
        paraQue: 'Demo de produto (não é página do PDF): conteúdo claro + chrome navy + primário azul + acento verde.',
        variantes: [
          { id: 'A', nome: 'Mock de shell', mock: 'mivHierarchy' },
          { id: 'B', nome: 'Shell no celular', mock: 'mivHierarchyMobile' },
        ],
      },
      {
        id: 'miv-dos-donts',
        nome: 'Proibições e checklist',
        paraQue: 'Resumo pedagógico do que fazer/evitar ao aplicar a marca em UI (derivado do MIV).',
        variantes: [
          { id: 'A', nome: 'Fazer / não fazer', mock: 'mivDosDonts' },
        ],
      },
    ],
  },
  {
    grupo: 'Ferramentas',
    items: [
      {
        id: 'miv-chart-gen',
        nome: 'Gerador de gráficos',
        paraQue:
          'Ferramenta editável (paleta Ecossis) para infográficos, gráficos e tabelas — exportável. App embutido; use tela cheia se precisar de espaço.',
        fullWidth: true,
        variantes: [
          { id: 'A', nome: 'Ferramenta ao vivo', mock: 'mivChartGen' },
        ],
      },
      {
        id: 'miv-glpi-agent',
        nome: 'Instalar agente GLPI',
        paraQue: 'Comandos para mapear a pasta pública e rodar o instalador do agente GLPI.',
        fullWidth: true,
        variantes: [{ id: 'A', nome: 'Comandos', mock: 'mivGlpiAgent' }],
      },
    ],
  },
]

export function flattenMivCatalog() {
  return MIV_CATALOG.flatMap((g) => g.items.map((it) => ({ ...it, grupo: g.grupo })))
}

export default MIV_CATALOG
